export default {
    state: {
        organogram: null,
        draggedItem: null,
    },
    getters: {
        getOrganogram(state) {
            return state.organogram;
        },
        getDraggedItem(state) {
            return state.draggedItem;
        },
        getNode: (state) => (id) => {
            let organogram = state.organogram;

            return new Promise((resolve) => {
                if (id == null) {
                    resolve(organogram);
                }

                organogram.forEach(node => {
                    if (node.id == id) {
                        resolve(node);
                    } else if (node.children.length > 0) {
                        node.children.find(el => {
                            findNodeRecusrive(el, id, resolve);
                        })
                    }
                })
            });
        },
    },
    mutations: {
        setOrganogram(state, data) {
            return state.organogram = data;
        },
        cleaOrganogram(state) {
            return state.organogram = null;
        },
        setDraggedItem(state, data) {
            state.draggedItem = data;
        },
        setDroppedItem(state, data) {
            state.droppedItem = data;
        }
    },
    actions: {
    },
}

function findNodeRecusrive(node, id, callback) {
    if (node.id == id) {
        callback(node);
    } else if (node.children.length > 0) {
        node.children.find(el => {
            findNodeRecusrive(el, id, callback);
        })
    }
}